import React, { useState } from 'react'
import { LightBox } from '@lion-design/core';
import styles from './styles.module.scss';

interface OutOfRangeDateProps {
    openAlertModal: boolean;
    closeModal: () => void;
}

export default function OutOfRangeDate({ openAlertModal, closeModal }: OutOfRangeDateProps) {

    function handleCloseModal() {
        closeModal()
    }

    return (
        <LightBox open={openAlertModal} ToggleLightBox={() => { }} closeBtn={false} width={390}>
            <div className={styles['lightbox-wrap']}>
                <div className={styles['text']}>您選擇的日期超過可以訂購的範圍，請選擇其他日期。</div>
                <div className={styles['confirm']} onClick={handleCloseModal}>確定</div>
            </div>
        </LightBox>
    )
}
